import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types/auth';
import Loader from 'components/Loader';

export default function AuthGuard({ children }: GuardProps) {
    const { isLoggedIn, isInitialized } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (isInitialized && !isLoggedIn) {
            navigate('login', {
                state: {
                    from: location.pathname
                },
                replace: true
            });
        }
    }, [isLoggedIn, isInitialized, navigate, location]);

    if (!isLoggedIn) {
        return <Loader />;
    }

    return children;
}

